import styled from "styled-components";
import { ReactComponent as SvgCircle } from "../../assets/svg/bg-circle-2.svg";
import { svgBgCompSharedStyles } from "../../config/theme/mixins";

export const SvgBgCircleOrange = styled(SvgCircle)`
  ${svgBgCompSharedStyles};
`;
